export const SHOW_LOOKUP = 'SHOW_LOOKUP';
export const LOOK_SEARCH = 'LOOK_SEARCH';
export const LOOKUP_LOADING = 'LOOKUP_LOADING';

export const UPDATE_SHOW_LOOKUP_QUERY = 'UPDATE_SHOW_LOOKUP_QUERY';
export const RESET_LOOKUP = 'RESET_LOOKUP';
export const LOOKUP_ERROR = 'LOOKUP_ERROR';



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/lookup/state/types.js